export default __webpack_public_path__ + "static/media/home-about-meteor-large-2.8638f0cd.png";